import clsx from "clsx";
import { Fragment } from "react";
import { PrimaryButton, SurfaceButton } from "components/atoms/Button";
import { HeroTitle, TextBadge } from "components/atoms/Text";

const Hero = () => {
    return (
        <Fragment>
            <header className={clsx(
                "w-full max-w-[1440px] mx-auto",
                "flex flex-col tablet:flex-row desktop:flex-row justify-between",
                "px-6 tablet:px-8 desktop:px-[120px] pb-[88px] phone:pb-12 tablet:pb-[48px]",
            )}>
                <div className="w-full tablet:max-w-[542px] desktop:max-w-[542px] mt-[69px] phone:mt-8 tablet:mt-[50px]">
                    <TextBadge>LinkedIn Proxy</TextBadge>
                    <HeroTitle classNames="tablet:!text-[48px] tablet:!leading-[64.8px]">LinkedIn HTTP Proxies</HeroTitle>
                    <p className="max-w-[435px] font-normal relative z-30 phone:text-md text-neutral-50 text-md tracking-text !leading-[27.2px] mt-4">Nunc arcu, quam nunc, fringilla vitae. Dolor commodo arcu dolor tincidunt phasellus aliquet amet eu. Tempus sit semper ultrices mi at lacinia. Donec venenatis, faucibus id et molestie curabitur ornare enim.</p>
                    <div className="w-full flex flex-col md:flex-row md:items-center md:space-x-6 space-y-4 md:space-y-0 desktop:mt-8 tablet:mt-8 phone:mt-8">
                        <PrimaryButton>Get Started</PrimaryButton>
                        <SurfaceButton>See Pricing</SurfaceButton>
                    </div>
                </div>
                <div className="w-full tablet:max-w-[452px] max-w-[520px] mt-8 tablet:mt-6 phone:mt-10">
                    <img src="/images/proxy/linkedin.svg" className="w-[520px] phone:h-[310px] h-[494px] tablet:w-[452px] tablet:h-[429px]" alt="proxy-hero" />
                </div>
            </header>
        </Fragment>
    );
};

export default Hero;